export default __webpack_public_path__ + "static/media/desmos.4c1ca1a2.png";